import { ModelBase } from 'store/model-base';
import { DeviceType } from 'my-account/constants';

export class StatementDataLine extends ModelBase {
    public static storeName: string = 'statementDataLine';

    public displayName: string;
    public dataConsumed: number;
    public dataCost: number;
    public lineNumber: string;
    public deviceType: string;
    public lineId: Id | string;
    public isPhone: boolean;
    public isTablet: boolean;
    public isWatch: boolean;
    public planSubgroup: string;
    public planCode: string;
    public planName?: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isPhone = data.deviceType?.toUpperCase() === DeviceType.PHONE;
        data.isTablet = data.deviceType?.toUpperCase() === DeviceType.TABLET;
        data.isWatch = data.deviceType?.toUpperCase() === DeviceType.SMART_WATCH;

        return super.create<T>(data);
    }
}
